/**
 * @generated SignedSource<<c20de92747c1544d389d3d93f4a0076d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PieceRendererNote_note$data = {
  readonly bulb_id: string;
  readonly note_start: number;
  readonly midi_number: number;
  readonly note_duration: number;
  readonly " $fragmentSpreads": FragmentRefs<"PieceRendererNoteTooltip_note">;
  readonly " $fragmentType": "PieceRendererNote_note";
};
export type PieceRendererNote_note$key = {
  readonly " $data"?: PieceRendererNote_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"PieceRendererNote_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PieceRendererNote_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bulb_id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "note_start",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "midi_number",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "note_duration",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PieceRendererNoteTooltip_note"
    }
  ],
  "type": "MusicPieceFileNote",
  "abstractKey": null
};

(node as any).hash = "b4536d89d43da17a58bb42b2073fa2cb";

export default node;
